import axios from "@axios";
import { formatNewsRadarConfigList } from "@/utils/formatting";

const DEFAULT_STATE = {
  configs: [],
  configList: [],
  aifAutoConfig: null,
  scoreMin: null,
  // Support de la veille : "written" | "video" (T7). Vit dans le store et non
  // dans l'URL — un lien profond passerait outre la garde superadmin de la vue
  // vidéo.
  mediaType: "written",

  // DbOverview :
  displayMode: "",
  origins: [],
  sites: [],
  sourceList: [],
  sources: [],
  dates: [],
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getConfigList: (state) => state.configList,
    getConfigs: (state) => state.configs,
    getAifAutoConfig: (state) => state.aifAutoConfig,
    getScoreMin: (state) => state.scoreMin,
    getMediaType: (state) => state.mediaType,

    // DbOverview :
    getDisplayMode: (state) =>
      state.displayMode ? state.displayMode : "masonry", // masonry|feed|dataTable
    getSites: (state) => state.sites,
    getOrigins: (state) => state.origins,
    getSourceList: (state) => state.sourceList,
    getSources: (state) => state.sources,
    getDates: (state) => state.dates,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setConfigs(state, payload) {
      state.configs = payload;
    },
    setConfigList(state, payload) {
      state.configList = payload;
    },
    setAifAutoConfig(state, payload) {
      state.aifAutoConfig = payload;
    },
    setScoreMin(state, payload) {
      state.scoreMin = payload;
    },
    setMediaType(state, payload) {
      state.mediaType = payload;
    },

    // DbOverview :
    setDisplayMode(state, payload) {
      state.displayMode = payload;
    },
    setOrigins(state, payload) {
      state.origins = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSourceList(state, payload) {
      state.sourceList = payload;
    },
    setSources(state, payload) {
      state.sources = payload;
    },
    setDates(state, payload) {
      state.dates = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    // `payload` : un site_id (usage historique, ConfigFilter) ou
    // { siteId, mediaType } quand l'appelant ne veut qu'un seul support.
    async getConfigList({ commit }, payload) {
      const { siteId, mediaType } =
        payload && typeof payload === "object"
          ? payload
          : { siteId: payload, mediaType: null };

      const {
        data: { items },
      } = await axios.get("/news-radar-configs/all", {
        params: {
          ...(siteId ? { site_id: siteId } : {}),
          ...(mediaType ? { media_type: mediaType } : {}),
        },
      });
      const formattedItems = formatNewsRadarConfigList(items);
      commit("setConfigList", formattedItems);

      return formattedItems;
    },

    updateMediaType({ commit }, payload) {
      commit("setMediaType", payload);
    },

    updateConfigs({ commit }, payload) {
      commit("setConfigs", payload);
    },
    updateScoreMin({ commit }, payload) {
      commit("setScoreMin", payload);
    },
    updateAifAutoConfig({ commit }, payload) {
      commit("setAifAutoConfig", payload);
      let configIds = [];
      if (Array.isArray(payload?.config_ids)) {
        configIds = payload.config_ids;
      } else if (payload?.configs?.length) {
        configIds = payload.configs.map((config) => config.id);
      }
      commit("setConfigs", configIds);
      commit("setScoreMin", payload?.min_score ?? null);
      if (payload?.site_id) {
        commit("setSites", payload.site_id);
      }
    },

    // DbOverview :
    updateDisplayMode({ commit }, payload) {
      commit("setDisplayMode", payload);
    },
    updateOrigins({ commit }, payload) {
      commit("setOrigins", payload);
    },
    async getSourceList({ commit }) {
      const { data } = await axios.get("/news-radar-sources/all");
      commit("setSourceList", data);

      return data;
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    updateSources({ commit }, payload) {
      commit("setSources", payload);
    },
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
  },
};
